import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const RecurringDeposit = () => {
  return (
    <>
      <TopBanner content={"Recurring Deposit"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Small Savings, Big Future</h2>
          <p>
            A Recurring Deposit (RD) helps you develop a saving habit by
            allowing you to deposit a fixed amount every month and earn interest
            on it over time. It’s a perfect plan for people with regular income
            who want to grow their savings steadily, without taking any risk.
          </p>

          <h3>Why Choose RDs?</h3>
          <ul>
            <li>Start with small monthly deposits</li>
            <li>Earn guaranteed interest over a fixed tenure</li>
            <li>Ideal for salaried individuals and disciplined savers</li>
            <li>Choose your duration from 6 months to 10 years</li>
            <li>No market risks or complications</li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default RecurringDeposit;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
